<div class="flex-row full column align-center position-relative p-24">
    <button type="button" class="btn p-0 color-secondary close-modal" (click)="closeDialog()">X</button>
    <div class="flex-row full column align-start row-gap-16">
        <h2 class="fs-22 fs-md-18 fw-7 color-secondary">Finvasia Account Details</h2>
        <div class="color-primary">
            Visit -<a href="https://trade.shoonya.com" target="_blank" class="hover-primary fw-7"> https://trade.shoonya.com </a> >>
            Login with your Finvaisa details provide the OTP generated to your mobile or email in the below felid.
        </div>
        <div class="flex-row content-center full">OR</div>
        <div class="color-primary">
            Login to your Finvasia account <a href="https://trade.shoonya.com" target="_blank" class="hover-primary fw-7"> https://trade.shoonya.com </a> >>
            set up TOTP on your mobile phone and provide your TOTP in below felid.
        </div>
        <form class="flex-row full column align-start row-gap-16" autocomplete="off" [formGroup]="finvasiaForm"
            (ngSubmit)="onSubmitForm()">
            <div class="flex-row full column align-start">
                <label class="fs-14 color-secondary mb-2">UID</label>
                <input type="text" class="border-1 color-primary width-100-pr m-0 p-11 fs-16 border-radius-4"
                    placeholder="UID" formControlName="uid">
            </div>
            <div class="flex-row full column align-start">
                <label class="fs-14 color-secondary mb-2">Password</label>
                <input type="password" class="border-1 color-primary width-100-pr m-0 p-11 fs-16 border-radius-4"
                    placeholder="Password" formControlName="password" autocomplete="new-password">
            </div>
            <div class="flex-row full column align-start">
                <label class="fs-14 color-secondary mb-2">OTP/TOTP</label>
                <input type="text" class="border-1 color-primary width-100-pr m-0 p-11 fs-16 border-radius-4"
                    placeholder="OTP" formControlName="otp">
            </div>
            <button type="submit" class="btn btn-primary btn-large width-100-pr"
                [disabled]="finvasiaForm.invalid">Submit</button>
        </form>
    </div>
</div>
